"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerFactory = void 0;
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var ServerFactory = /** @class */ (function () {
    function ServerFactory() {
    }
    Object.defineProperty(ServerFactory, "Instance", {
        get: function () {
            return this.instance || (this.instance = new this());
        },
        enumerable: false,
        configurable: true
    });
    ServerFactory.prototype.setWrappedRequester = function (wrappedRequester) {
        ServerFactory.Instance.wrappedRequester = wrappedRequester;
    };
    ServerFactory.prototype.getWrappedRequester = function () {
        if (!ServerFactory.Instance.wrappedRequester) {
            ServerFactory.Instance.wrappedRequester = new vizportal_webclient_api_1.WebClientRequesterWrapper(new vizportal_webclient_api_1.WebClientFetchRequester());
        }
        return ServerFactory.Instance.wrappedRequester;
    };
    return ServerFactory;
}());
exports.ServerFactory = ServerFactory;
//# sourceMappingURL=ServerFactory.js.map